import { useEffect, useState } from 'react';

import { nutsCodes } from '../../enums/nutsCodes';

const KRAJ_OPTIONS = Object.values(nutsCodes).map(({ code, name }) => ({ code, name }));
const KRAJ_CODES = new Set(KRAJ_OPTIONS.map(region => region.code));
const KRAJ_NAME_BY_CODE = KRAJ_OPTIONS.reduce((carry, region) => {
    carry[region.code] = region.name;
    return carry;
}, {});

// Full kraj labels matching cr.mjs ("Jihočeský kraj") so options/results in different
// quizzes use a single canonical form.
export const KRAJ_FULL_LABEL_BY_CODE = {
    CZ010: 'Hlavní město Praha',
    CZ020: 'Středočeský kraj',
    CZ031: 'Jihočeský kraj',
    CZ032: 'Plzeňský kraj',
    CZ041: 'Karlovarský kraj',
    CZ042: 'Ústecký kraj',
    CZ051: 'Liberecký kraj',
    CZ052: 'Královéhradecký kraj',
    CZ053: 'Pardubický kraj',
    CZ063: 'Kraj Vysočina',
    CZ064: 'Jihomoravský kraj',
    CZ071: 'Olomoucký kraj',
    CZ072: 'Zlínský kraj',
    CZ080: 'Moravskoslezský kraj',
};
export const ALL_KRAJ_LABELS = Object.values(KRAJ_FULL_LABEL_BY_CODE).sort((a, b) =>
    a.localeCompare(b, 'cs'),
);

let cachedKrajFeatures = null;

export const useKrajFeatures = () => {
    const [features, setFeatures] = useState(cachedKrajFeatures);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (cachedKrajFeatures) {
            setFeatures(cachedKrajFeatures);
            return;
        }

        const loadFeatures = async () => {
            try {
                const publicUrl = process.env.PUBLIC_URL || '';
                const response = await fetch(`${publicUrl}/kraje-only.geo.json`);
                if (!response.ok) {
                    throw new Error('Nepodařilo se načíst kraje-only.geo.json');
                }
                const geoJson = await response.json();
                cachedKrajFeatures = geoJson.features
                    .filter(feature => KRAJ_CODES.has(feature.id))
                    .sort((a, b) => KRAJ_NAME_BY_CODE[a.id].localeCompare(KRAJ_NAME_BY_CODE[b.id], 'cs'));
                setFeatures(cachedKrajFeatures);
            } catch (err) {
                setError(err);
            }
        };

        loadFeatures();
    }, []);

    return { features, error };
};

export { KRAJ_OPTIONS, KRAJ_CODES, KRAJ_NAME_BY_CODE };
